module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_albino.8875f29e.png";